export default "__VITE_ASSET__Zxe_66tp__"